export const toKebabCase = (str: string): string => {
  return str
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase();
};

export const fromKebabCase = (str: string): string => {
  return str.replace(/-/g, ' ').replace(/^./, (char) => char.toLowerCase());
};

export const toTitleCaseFromSnakeCase = (str: string): string =>
  str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

/** Must match `@payloadcms/plugin-mcp` `dist/utils/camelCase.js`: capability keys are looked up by this. */
export const toCamelCase = (str: string): string =>
  str
    .replace(/[-_\s]+(.)?/g, (_, chr: string | undefined) => (chr ? chr.toUpperCase() : ''))
    .replace(/^(.)/, (_, chr: string) => chr.toLowerCase());
